module.exports = __webpack_public_path__ + "media/images/v2/kwivrr_logo-0d372c11a24f5772a31925cb38e6183d.png";